import React, { useEffect } from 'react'
import Information from './Information/Information'

function AccountInfo() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when component mounts
}, []);
  return (
    <>
    <Information/>
    </>
  )
}

export default AccountInfo